<template>
    <div>
      <home :disposeData="disposeData" v-if="disposeData.organization_id"></home>
    </div>
</template>

<script>
import home from './home'
export default {
  components:{
    home
  },
  data(){
    return{
      disposeData: {
        is_default: 0,
        organization_id: null,
      },
    }
  },
  mounted() {
    let info = JSON.parse(localStorage.getItem('session'))
    console.log(info)
    if(info){
      this.disposeData.organization_id = info.organization_id
      console.log(this.disposeData)
    }

  },
  name: 'index'
};
</script>

<style scoped>

</style>
